import styled from 'styled-components';

const Title = styled.h2`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  margin: 0 0 16px;
`;

export { Title };
